module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "filter-date-range",
    class: _vm.cssClass
  }, [_c('div', {
    staticClass: "filter-date-range-label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "filter-date-range-start"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "startdatepickertrigger"
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('input', {
    staticClass: "filter-date-range-input",
    attrs: {
      "type": "text",
      "id": "start_date_picker",
      "name": "start_date_picker"
    },
    on: {
      "change": _vm.setStartDate
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "filter-date-range-thru"
  }, [_vm._v("thru  ")]), _vm._v(" "), _c('div', {
    staticClass: "filter-date-range-end"
  }, [_c('i', {
    staticClass: "material-icons",
    attrs: {
      "id": "enddatepickertrigger"
    }
  }, [_vm._v("date_range")]), _vm._v(" "), _c('input', {
    staticClass: "filter-date-range-input",
    attrs: {
      "type": "text",
      "id": "end_date_picker",
      "name": "end_date_picker"
    },
    on: {
      "change": _vm.setEndDate
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "filter-date-range-error",
    class: [{
      's-error': !_vm.isValidEndDate
    }]
  }, [_vm._v("Must be later than first date.")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12769fc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterDateRange.vue
// module id = 454
// module chunks = 1